if (!customElements.get('bfcm-tab-products')) {
  class BfcmTabProducts extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('.bfcm-tab-products__tab-list');
      this.containerList = this.querySelectorAll('.bfcm-tab-products__products-container');

      this.bundles = this.querySelectorAll('.card-product-4__bundles li');
      this.symbol = this.getAttribute('data-price-symbol');

      this.initTabEvent();

      this.initEvent();
    }

    initTabEvent() {
      const wrapper = this.tabList; // 保存 wrapper 引用
      const containerWidth = this.tabList.clientWidth;

      this.tabList.addEventListener('click', (e) => {
        const target = e.target;
        if (e.target.classList.contains('bfcm-tab-products__tab-item')) {
          const tab = target.getAttribute('data-tab');
          this.tabList.querySelector('.active')?.classList.remove('active');
          target.classList.add('active');
          for (const [index, container] of this.containerList.entries()) {
            const containerForTab = container.getAttribute('data-tab');
            if (containerForTab == tab) {
              container.classList.add('active');
              if(window.innerWidth > 768) {
                const learnMoreContainerPC = this.querySelector('.learn-more__pc');
                if(learnMoreContainerPC) {
                  if(learnMoreContainerPC) {
                    if (learnMoreContainerPC.classList.contains('hide')) {
                      console.log('元素被隐藏了');
                    } else {
                      console.log('元素显示中');
                      learnMoreContainerPC.style.display = 'flex';
                    }
                  }
                }

              }else {
                const learnMoreContainerMB = this.querySelector('.learn-more__mb');
                if(learnMoreContainerMB) {
                  if(learnMoreContainerMB) {
                    if (learnMoreContainerMB.classList.contains('hide')) {
                      console.log('元素被隐藏了');
                    } else {
                      console.log('元素显示中');
                      learnMoreContainerMB.style.display = 'flex';
                    }
                  }
                }
              }
            } else {
              container.classList.remove('active');
            }
            
          }

          // Scroll into view
          const container = this.tabList;
          const containerLeft = container.scrollLeft;
          const containerWidth = container.clientWidth;
          const itemLeft = target.offsetLeft - container.offsetLeft;
          const itemWidth = target.offsetWidth;
          // console.log(containerLeft, containerWidth, itemLeft, itemWidth);
          if (itemLeft < containerLeft || itemLeft + itemWidth > containerLeft + containerWidth) {
            container.scroll({
              left: itemLeft,
              behavior: 'smooth'
            });
          }

          
          if(target){
            const itemLeft = target.offsetLeft;
            const itemWidth = target.offsetWidth;
            let translateX = itemLeft - (containerWidth / 2 - itemWidth / 2);
            translateX = Math.max(0, translateX); // 防止负值
            // 设置 transform
            wrapper.style.transition = 'transform 0.4s';
            wrapper.style.transform = `translate3d(${-translateX}px, 0, 0)`;
          }
         
        }
      });
    }

    /**
     * @param {HTMLElement} checkBox 
     * @param {HTMLElement} quantityInput 
     */
    update(checkBox, quantityInput) {
      const bundleElement = checkBox.closest('li');
      const cardProduct = bundleElement.closest('.card-product-4');
      const bundleVariantId = bundleElement.getAttribute('data-bundle-variant-id');
      const buyButton = cardProduct.querySelector('buy-now-button');
      const addButton = cardProduct.querySelector('add-cart-button');
      let ids = buyButton.getAttribute('data-variant-id').split(',');
      let quantityList = buyButton.getAttribute('data-quantity').split(',');
      if (checkBox.checked) {
        bundleElement.classList.add('active');
        const findIndex = ids.findIndex((id) => id == bundleVariantId);
        if (findIndex <= -1) {
          // add id, quantity
          ids.push(bundleVariantId);
          quantityList.push(quantityInput.value > 1 ? quantityInput.value : 1);
        } else {
          // update quantity
          quantityList[findIndex] = quantityInput.value > 1 ? quantityInput.value : 1;
        }
      } else {
        const findIndex = ids.findIndex((id) => id == bundleVariantId);
        if (findIndex > -1) {
          // remove id, quantity
          ids.splice(findIndex, 1);
          quantityList.splice(findIndex, 1);
        }
        bundleElement.classList.remove('active');
      }
      buyButton.setAttribute('data-variant-id', ids.join(','));
      buyButton.setAttribute('data-quantity', quantityList.join(','));
      addButton.setAttribute('data-variant-id', ids.join(','));
      addButton.setAttribute('data-quantity', quantityList.join(','));

      // Update bundle price 
      const bundlePriceElement = bundleElement.querySelector('[data-bundle-price]');
      const bundleComparePriceElement = bundleElement.querySelector('[data-bundle-compare-price]');
      if (bundlePriceElement && bundleComparePriceElement) {
        const bundlePrice = Number(bundlePriceElement.getAttribute('data-bundle-price'));
        const bundleComparePrice = Number(bundleComparePriceElement.getAttribute('data-bundle-compare-price'));
        const quantity = bundleElement.querySelector('[data-quantity-variant-id]').value;
        const finalPrice = quantity * bundlePrice;
        const finalComparePrice = quantity * bundleComparePrice;
        bundlePriceElement.innerHTML = this.formatMoney(finalPrice);
        bundleComparePriceElement.innerHTML = finalPrice < finalComparePrice
          ? this.formatMoney(finalComparePrice)
          : '';

        // this.renderMainPrice(cardProduct);
      }
    }

    /**
     * @param {HTMLElement} cardProduct 
     */
    renderMainPrice(cardProduct) {
      const priceElement = cardProduct.querySelector('[data-price]');
      const comparePriceElement = cardProduct.querySelector('[data-compare-price]');
      if (priceElement && comparePriceElement) {
        const price = Number(priceElement.getAttribute('data-price'));
        const comparePrice = Number(comparePriceElement.getAttribute('data-compare-price'));

        let finalPrice = price;
        let finalComparePrice = comparePrice;
        for (const bundle of cardProduct.querySelectorAll('.card-product-4__bundle')) {
          const isChecked = bundle.querySelector('[type="checkbox"]').checked;
          if (isChecked) {
            const bundlePrice = Number(bundle.querySelector('[data-bundle-price]').getAttribute('data-bundle-price'));
            const bundleComparePrice = Number(bundle.querySelector('[data-bundle-compare-price]').getAttribute('data-bundle-compare-price'));
            const quantity = bundle.querySelector('[data-quantity-variant-id]').value;
            finalPrice += (quantity * bundlePrice);
            finalComparePrice += (quantity * bundleComparePrice);
          }
        }
        priceElement.innerHTML = this.formatMoney(finalPrice);
        comparePriceElement.innerHTML = finalPrice < finalComparePrice
          ? this.formatMoney(finalComparePrice)
          : '';
      }
    }


    initEvent() {
      for (const bundle of this.bundles) {
        const checkBox = bundle.querySelector('input[type="checkbox"]');
        const quantityInput = bundle.querySelector('input[data-quantity-variant-id]');
        this.update(checkBox, quantityInput);
        checkBox.addEventListener('change', (e) => {
          this.update(checkBox, quantityInput);
        });
        quantityInput.addEventListener('change', (e) => {
          this.update(checkBox, quantityInput);
        });
      }
    }

     formatMoney(cents, format) {
      var moneyFormat = '${{amount}}';

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /{{\s*(\w+)\s*}}/;
      var formatString =
        format ||
        (window.theme && window.theme.moneyFormat) ||
        moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return '0';
        }

        number = (number / 100).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      var match = formatString.match(placeholderRegex);

      if (!match) {
        return formatString;
      }

      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  customElements.define('bfcm-tab-products', BfcmTabProducts);
}


if (!customElements.get('bfcm-tab-products-swiper')) {
  class BfcmTabProductsSwiper extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 2);
      this._swiperContainer = this;

      const isMobile = `(max-width: 768px)`;
      const isMobileMQL = window.matchMedia(isMobile);

      isMobileMQL.addEventListener('change', (event) => {
        if (!event.matches) {
          this.createSlider();
        } else if (this.mySwiper) {
          this.destroySwiper();
        }
      });
      if (!isMobileMQL.matches) this.createSlider();
    }

    createSlider() {
      // const nextButton = this.querySelector('.swiper-btn-next');
      // const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);
      const elementID = this.dataset.id;
      const nextButton = this.parentElement.querySelector(`#${elementID} .swiper-btn-next`);
      const prevButton = this.parentElement.querySelector(`#${elementID} .swiper-btn-prev`);
      
      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 4,
        spaceBetween: 20,
        loop: false,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }
      });
    }

    destroySwiper() {
      this._swiperInstance.destroy();
    }
  }

  customElements.define('bfcm-tab-products-swiper', BfcmTabProductsSwiper);
}

document.addEventListener('DOMContentLoaded', function() {
  // 初始化 Swiper
  new Swiper('.tab-swiper', {
    // 横向滚动
    direction: 'horizontal',
    // 滑动项宽度自适应（根据内容宽度）
    slidesPerView: 'auto',
    // 开启自由拖拽（按住可任意滚动，松手后停止）
    freeMode: true,
    mousewheel: true,        // PC 鼠标滚轮横向滚动
    grabCursor: true,        // 鼠标抓手体验更好
    // 滑动项之间的间距（对应原 gap）
    spaceBetween: window.innerWidth > 768 ? 24 : 16,
    // 可选：触摸/鼠标灵敏度调整
    freeModeMomentumRatio: 0.5, // 数值越小，拖拽后惯性越小
  });


  const couponElements = document.querySelectorAll('.card-product-4__coupon');
  couponElements.forEach(couponEl => {
    const copyIcon = couponEl.querySelector('svg:not(.icon-tick)');
    const tickIcon = couponEl.querySelector('.icon-tick');
    const couponCode = couponEl.querySelector('strong');
    
    if (!couponCode || !copyIcon || !tickIcon) return;
    
    copyIcon.addEventListener('click', function(e) {
      e.stopPropagation();
      
      navigator.clipboard.writeText(couponCode.textContent.trim())
        .then(() => {
          copyIcon.style.display = 'none';
          tickIcon.style.display = 'block';
          
          setTimeout(() => {
            tickIcon.style.display = 'none';
            copyIcon.style.display = 'block';
          }, 3000);
        })
        .catch(err => {
          console.error('Failed to copy coupon code: ', err);
        });
    });
  });

  const giftCards = document.querySelectorAll(".card-product-4__price-gift-xms");
  giftCards.forEach(card => {
    const link = card.dataset.link;
    if (link && link.trim() !== "") {
      card.style.cursor = "pointer";
      card.addEventListener("click", (e) => {
        e.stopPropagation();   // 阻止冒泡，父级不会被触发
        window.location.href = link;  // 跳转
      });
    }
  });


  const btn = document.getElementById("bfcm-tab-products-v1-xms-view-more-Btn");
  const blocks = document.querySelectorAll(".card-product-4-block-item-xms");

  if (!btn) return;

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  let visibleCount = isMobile ? 2 : 4; // 移动端初始显示2个，PC显示4个
  const totalCount = blocks.length;



  function updateBlocks() {
    for (let i = 0; i < totalCount; i++) {
      if (i < visibleCount) blocks[i].classList.remove("card-product-4-block-item-xms-hidden");
      else blocks[i].classList.add("card-product-4-block-item-xms-hidden");
    }

    if (visibleCount >= totalCount) btn.style.display = "none";
  }

  // 初始化显示
  updateBlocks();





  btn.addEventListener("click", () => {
    if (visibleCount === (isMobile ? 2 : 4)) visibleCount = isMobile ? 4 : 8;
    else visibleCount = totalCount;

    updateBlocks();
  });
  
 

});